import { watch } from 'vue'
import { i18n } from '@/i18n'

var pageTitleBrand = 'soNomad'
var activeTitleKey: string | undefined
var activeCustomTitle: string | undefined

export function applyPageTitle(titleKey?: string, customTitle?: string) {
  activeTitleKey = titleKey
  activeCustomTitle = customTitle

  if (customTitle) {
    document.title = `${customTitle} | ${pageTitleBrand}`
    return
  }

  if (titleKey) {
    document.title = `${i18n.global.t(titleKey)} | ${pageTitleBrand}`
    return
  }

  document.title = i18n.global.t('PageTitleDefault')
}

export function initPageTitleLocaleWatcher() {
  watch(i18n.global.locale, () => {
    applyPageTitle(activeTitleKey, activeCustomTitle)
  })
}
